function addMetaData(project) {
  let metaData = {};

  if (project.metaData) {
    metaData = project.metaData;
  }

  const utmKeys = Object.keys(sessionStorage).filter((key) =>
    key.startsWith('utm_')
  );

  utmKeys.forEach((key) => {
    const value = sessionStorage.getItem(key);
    if (value && !metaData[key]) {
      metaData[key] = value;
    }
  });

  return metaData;
}

export default addMetaData;
